import { useLocation } from 'react-router-dom';
import { ActivityFeedFilters } from '../../../services/modules/activityFeed/activityFeed.types';
import {
  ACTIVITY_FEED_FILTER_SEARCH_PARAMS,
  parseActivityFeedDate,
  parseActivityFeedDomains,
  parseActivityFeedSource,
} from '../activityFeed.constants';

export const useActivityFeedFilterSearchParams = (): ActivityFeedFilters => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  return {
    domain: parseActivityFeedDomains(
      searchParams.getAll(ACTIVITY_FEED_FILTER_SEARCH_PARAMS.domain),
    ),
    source: parseActivityFeedSource(searchParams.get(ACTIVITY_FEED_FILTER_SEARCH_PARAMS.source)),
    from: parseActivityFeedDate(searchParams.get(ACTIVITY_FEED_FILTER_SEARCH_PARAMS.from)),
    to: parseActivityFeedDate(searchParams.get(ACTIVITY_FEED_FILTER_SEARCH_PARAMS.to)),
  };
};
